// Корректировка рейса у заказчика: /api/v2/trip-correction/* (erp-backend, модуль src/trip_correction).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchCorrectionPreview(tripId, parts, reason) {
  const params = {}
  if (parts) params.parts = parts
  if (reason) params.reason = reason
  const { data } = await api.get('trip-correction/' + tripId + '/preview', { params })
  return data
}

export async function requestCorrection(tripId, parts, reason) {
  const { data } = await api.post('trip-correction/' + tripId + '/request', { parts, reason: reason || '' })
  return data
}
